import { OrganizationProfile, useOrganization } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { tokens } from '../../../ad/theme';

// Team / organization settings (MIS-815 / Task 34). Clerk's <OrganizationProfile
// /> manages members, roles and invitations — but only renders meaningfully when
// the user has an ACTIVE organization. Users in just a personal tenant have no
// org (useOrganization().organization === null), so we guard that case with a
// friendly message instead of an empty component. Gated by _authenticated.tsx's
// beforeLoad sign-in check.
export const Route = createFileRoute('/_authenticated/settings/team')({
  component: TeamSettingsPage,
});

function TeamSettingsPage() {
  const { organization, isLoaded } = useOrganization();

  // The embedded <OrganizationProfile /> is themed via the ClerkProvider
  // appearance cascade (clerk-appearance.ts); the heading + helper copy use the
  // dark fg tokens so they sit on the dark shell instead of stock light-mode gray.
  return (
    <div className="p-8">
      <h1 className="mb-6 text-2xl font-semibold" style={{ color: tokens.color.fg0 }}>
        Team Settings
      </h1>
      {!isLoaded ? (
        <p className="text-sm" style={{ color: tokens.color.fg1 }}>
          Loading…
        </p>
      ) : organization ? (
        <OrganizationProfile />
      ) : (
        <p className="text-sm" style={{ color: tokens.color.fg1 }}>
          You don&rsquo;t have a team yet — create one from the Tenants page to manage members and
          invitations.
        </p>
      )}
    </div>
  );
}
